import React from 'react';
import { Container } from '@exxonmobil/react-unity';
import styled from 'styled-components';

interface Props {
  errorMessage?: string;
}
const NotFound = ({ errorMessage }: Props) => {
  return (
    <Container>
      <CenteredContainer>
        <Title>404</Title>
        <MessageContainer>{errorMessage || 'Page Not Found'}</MessageContainer>
      </CenteredContainer>
    </Container>
  );
};

const CenteredContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Title = styled.h1`
  font-size: 9rem;
`;

const MessageContainer = styled.p`
  text-align: center;
`;

export default NotFound;
